var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'NLink' : 'button',{tag:"component",class:( _obj = {}, _obj[_vm.css.tab] = true, _obj[_vm.css[_vm.theme]] = true, _obj[_vm.css.active] = _vm.isActive, _obj[_vm.css.bold] = _vm.activeBold, _obj ),attrs:{"to":_vm.to ? _vm.to : null,"type":_vm.to ? null : 'button'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }